import { connect } from 'react-redux';

import { assign as _assign } from 'lodash';

import {
  CreateFormProps,
  GlobalState,
  formatMessage
} from '../../../api';

import {
  createForm, 
  FormValues
} from '../../../api/models/Form/Form';

import {
  editUserDataFormValues, EditUserDataModel,
} from '../../../api/models/Registration/user-data';

// import { requestAPIActions,RequestApiHttpPayload, loadLogout } from 'loopback-react-request';

import MESSAGES from '../../Pages/Profile/Account-Profile/AccountProfile.messages';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';

const accountProfileFormProperty = createForm<EditUserDataModel, CreateFormProps<EditUserDataModel>>({
  className: 'partial-login-form my-0 mx-auto',
  dispatchData: (dispatch, values: FormValues<EditUserDataModel>) => { 
    const userDataId = (values as FormValues<EditUserDataModel & {id: string}>).id;
    delete (values as FormValues<EditUserDataModel & {id: string}>).id;
    dispatch(requestAPIActions.load<RequestApiHttpPayload>(
      'userData', {
        url: `/UserData/${userDataId}`,
        options: {
          method: 'PATCH',
          data: values,
        },
      },
      true
    )
  )},
  formFields: editUserDataFormValues(),
  initialValues: 'state',
  preSubmit: (values: FormValues<EditUserDataModel>, state: GlobalState | undefined) => {
    const userData = state && state.userData && state.userData.result;
    return userData && _assign({}, values, {
      branch: userData.branch,
      id: userData.id,
      lang: userData.lang,
      userId: userData.userId,
      validated: userData.validated,
    }) || values;
  },
  redirectTo: '/profile/account',
  shouldRedirect: true,
  stateKeys: 'userData',
  submitButton: {
    text: formatMessage({...MESSAGES.accountProfileButton}),
    className: 'register-button mt-4 w-60'
  }
})();

export const AccountProfileForm = connect((state: GlobalState) => ({state}))(accountProfileFormProperty);